import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query'
import { AxiosError } from 'axios'
import type { FileWithPath } from 'react-dropzone'

import axios from '../../lib/axios'

export type UploadLabelParams = { assets: FileWithPath[] }

export const uploadLabelXls = async ({
  ...data
}: UploadLabelParams): Promise<void> => {
  const formData = new FormData()

  for (const asset of data.assets) {
    formData.append('assets[]', asset)
  }

  // eslint-disable-next-line no-useless-catch

  const { data: result } = await axios.post<void>(
    `/api/order-jobs/import`,
    formData,
  )

  return result
}

export const useUploadLabelXls = (
  options?: UseMutationOptions<void, AxiosError, UploadLabelParams, unknown>,
): UseMutationResult<void, AxiosError, UploadLabelParams, unknown> => {
  return useMutation({
    mutationFn: uploadLabelXls,
    ...options,
  })
}
